import {Avatar, Heading, Stack, VStack, Wrap, WrapItem} from '@chakra-ui/react'
import {FaLinkedin, FaTwitter} from 'react-icons/fa'

import {colors} from 'config/colors'
import {space} from 'config/theme'
import Link from './link'

type Person = Record<string, unknown> & {
  linkedIn?: string
  name?: string
  photo?: string
  title?: string
  twitter?: string
}

const team: Person[] = [
  {
    name: 'Andrew Byrd',
    photo: '/img/andrew.png',
    title: 'Principal',
    twitter: 'globalvoid',
    linkedIn: 'byrdandrew'
  },
  {
    name: 'Anson Stewart, PhD',
    photo: '/img/anson.jpg',
    title: 'Research',
    twitter: 'ansoncfit',
    linkedIn: 'ansonstewart'
  },
  {
    name: 'Trevor Gerhardt',
    photo: '/img/trevor.png',
    title: 'Developer',
    twitter: 'trevorgerhardt',
    linkedIn: 'trevorgerhardt'
  }
]

export default function TeamGrid() {
  return (
    <Wrap justify='center' spacing={space.xl} width='100%'>
      {team.map((person) => (
        <WrapItem key={person.name}>
          <VStack spacing={space.md}>
            <Avatar
              borderWidth='1px'
              borderColor={colors[50]}
              name={person.name}
              size='2xl'
              src={person.photo}
            />
            <VStack spacing={space.xs}>
              <Heading size='md'>{person.name}</Heading>
              <Heading color={colors[600]} size='sm' textTransform='uppercase'>
                {person.title}
              </Heading>
              <Stack isInline>
                {person.twitter && (
                  <Link href={`https://twitter.com/${person.twitter}`}>
                    <FaTwitter />
                  </Link>
                )}
                {person.linkedIn && (
                  <Link href={`https://linkedin.com/in/${person.linkedIn}`}>
                    <FaLinkedin />
                  </Link>
                )}
              </Stack>
            </VStack>
          </VStack>
        </WrapItem>
      ))}
    </Wrap>
  )
}
